import React from 'react';
import { useGetLiveActivitiesQuery } from 'app/api/backendApiSlice';

const BackendHome = () => {
  const {
    data: activities = [],
    isLoading,
    error,
  } = useGetLiveActivitiesQuery();

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading activities</div>;

  return (
    <div className="backend-home">
      <h1>Live Activities</h1>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Full Name</th>
            <th>Park Name</th>
            <th>Trail Name</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((activity) => (
            <tr key={activity.id}>
              <td>{activity.id}</td>
              <td>{activity.fullname}</td>
              <td>{activity.parkname}</td>
              <td>{activity.trailname}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BackendHome;
